import { AlertCircle, Ban, CheckCircle, Clock, LucideIcon } from 'lucide-react';
import { EnumTableConfig } from '@/components/table/_fieldDefinitions/enum/EnumTableConfig.ts';
import { toneEnumConfig } from '@/components/table/_fieldDefinitions/enum/enumToneConfig.ts';
import { PlannedTransactionPaymentStatus } from '@/features/public/bookingSummary/types/PlannedTransactionPaymentStatus.ts';
import {
  PLANNED_TRANSACTION_PAYMENT_STATUS_LABELS,
  PLANNED_TRANSACTION_PAYMENT_STATUS_TONE,
} from '@/features/public/bookingSummary/types/PlannedTransactionPaymentStatus.utils.ts';

/** Ikona jest jedyną rzeczą, której tabela nie dzieli z resztą aplikacji. */
const STATUS_ICONS: Record<PlannedTransactionPaymentStatus, LucideIcon> = {
  [PlannedTransactionPaymentStatus.AWAITING_PAYMENT]: Clock,
  [PlannedTransactionPaymentStatus.PAID]: CheckCircle,
  [PlannedTransactionPaymentStatus.OVERDUE]: AlertCircle,
  [PlannedTransactionPaymentStatus.CANCELLED]: Ban,
};

export const plannedTransactionPaymentStatusTableConfig: EnumTableConfig =
  Object.fromEntries(
    Object.values(PlannedTransactionPaymentStatus).map((status) => [
      status,
      toneEnumConfig(
        PLANNED_TRANSACTION_PAYMENT_STATUS_LABELS[status],
        PLANNED_TRANSACTION_PAYMENT_STATUS_TONE[status],
        STATUS_ICONS[status],
      ),
    ]),
  );
